import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { CvMapSignalStore } from './cv-map-signal-store';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe } from 'rxjs';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import { Location } from '../../../../models/locations-models/location';

export function withCvMapLifecycle<_>() {
  return signalStoreFeature(
      { state: type<CvMapSignalStore>() },
      withMethods((signalStore) => ({
        // EFFECTS - start in onInit
        // disable continueAfterValidation if end of list has been reached
        overrideContinueAfterValidation: rxMethod<boolean>(pipe(
            distinctUntilChanged(),
            tap((canContinue) => {
              if (!canContinue) {
                patchState(signalStore, { continueAfterValidation: false });
              }
            }),
        )),
        // Remove custom, autocomplete marker on location change: user selected another location,
        // coordinates were validated/invalidated, etc.
        // Also leads to info window getting closed (component listens to infoWindowMarkerId change)
        clearTransientMarkers: rxMethod<Location>(pipe(
            tap(() => {
              patchState(signalStore, {
                customMarker: null,
                infoWindowMarkerId: null,
                autocompleteMarker: null,
              });
            }),
        )),
      })),
  );
}